import type { Person } from '../../../eventsApi/persons/person'
import type { Invoice } from '../../../posApi/invoices/invoice'
import type { User } from '../../../usersApi/users/user'
import type { FormTemplate } from '../form-templates/form-template'
import type { FormDataContent } from './form-data-content'

export class FormData {
    formDataId?: string
    companyId?: string
    personId: string
    invoiceId?: string
    billId?: string
    content: FormDataContent[]
    status?: number
    createdAt?: Date
    updatedAt?: Date
    formTemplateId?: string
    template?: FormTemplate
    person?: Person
    attendantId?: string
    attendant?: User
    score?: number
    scoreMax?: number
    hash?: string
    metadata?: FormDataMetadata
    accessRead?: string[]
    documentId?: string
    documentType?: 'invoice' | 'bill'
    document?: any
}

export class FormDataMetadata {
    requestIP: string
    userAgent: string
    originalURL: string
    time: Date
}
